import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaystackButton } from './PaystackButton';
import { Check, Mail } from 'lucide-react';
export function PricingSection() {
  const [email, setEmail] = useState('');
  const [showEmailInput, setShowEmailInput] = useState(false);
  const navigate = useNavigate();
  const handleEnrollClick = () => {
    setShowEmailInput(true);
  };
  const handlePaymentSuccess = (reference: string) => {
    // Redirect to enrollment form page after successful payment
    navigate('/enrollment-form');
  };
  const handlePaymentClose = () => {
    console.log('Payment window closed');
  };
  return <div className="bg-white rounded-2xl shadow-xl border-2 border-blue-100 p-8 sticky top-24" data-id="element-423">
      <div className="mb-6" data-id="element-424">
        <div className="flex items-baseline gap-2 mb-2" data-id="element-425">
          <span className="text-4xl font-bold text-gray-900" data-id="element-426">₦100,000</span>
          <span className="text-gray-600" data-id="element-427">/ $67</span>
        </div>
        <p className="text-sm text-gray-600" data-id="element-428">
          One-time payment for full course access
        </p>
      </div>

      <div className="space-y-4 mb-8" data-id="element-429">
        <div className="flex items-start gap-3" data-id="element-430">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-431" />
          <span className="text-gray-700" data-id="element-432">8-week comprehensive program</span>
        </div>
        <div className="flex items-start gap-3" data-id="element-433">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-434" />
          <span className="text-gray-700" data-id="element-435">
            Live sessions with expert instructors
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-436">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-437" />
          <span className="text-gray-700" data-id="element-438">
            Lifetime access to course materials
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-439">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-440" />
          <span className="text-gray-700" data-id="element-441">
            Professional certificate upon completion
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-442">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-443" />
          <span className="text-gray-700" data-id="element-444">Portfolio templates and tools</span>
        </div>
        <div className="flex items-start gap-3" data-id="element-445">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-446" />
          <span className="text-gray-700" data-id="element-447">
            Career support and job placement assistance
          </span>
        </div>
      </div>

      {!showEmailInput ? <button onClick={handleEnrollClick} className="w-full bg-blue-600 text-white font-semibold py-4 px-6 rounded-full hover:bg-blue-700 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 transform" data-id="element-448">
          Enroll Now - Limited Slots
        </button> : <div className="space-y-4" data-id="element-449">
          <div data-id="element-450">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-451">
              Enter your email to proceed
            </label>
            <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your.email@example.com" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors duration-200" required data-id="element-452" />
          </div>
          <PaystackButton amount={100000} email={email} onSuccess={handlePaymentSuccess} onClose={handlePaymentClose} variant="primary" fullWidth data-id="element-453">
            Pay ₦100,000
          </PaystackButton>
          <button onClick={() => setShowEmailInput(false)} className="w-full text-gray-600 text-sm hover:text-gray-800 transition-colors duration-200" data-id="element-454">
            Cancel
          </button>
        </div>}

      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-455">
        <div className="bg-green-50 rounded-lg p-4 border border-green-200" data-id="element-456">
          <p className="text-sm text-green-900 font-medium mb-2" data-id="element-457">
            🎓 Special Group Rates Available
          </p>
          <p className="text-xs text-green-800 mb-3" data-id="element-458">
            Organizations, schools, or groups interested in bulk purchase can
            get tailored pricing.
          </p>
          <a href="mailto:support@myskillzhq.com" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 font-medium transition-colors duration-200" data-id="element-459">
            <Mail className="w-4 h-4" data-id="element-460" />
            support@myskillzhq.com
          </a>
        </div>
      </div>
    </div>;
}